import React from 'react';
import { SectionProps } from '../types';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { SidebarSectionEnum } from '../enums';

const ImportantNotes = ({ data, ...rest }: SectionProps) => {
  if (!data?.notes?.length) {
    return null;
  }

  return (
    <section {...rest} id={SidebarSectionEnum.ImportantNotes}>
      <h4 className="text-md font-semibold text-slate-700">
        <ExclamationCircleOutlined className="text-md mr-2 text-amber-400" />
        Important Notes
      </h4>
      {data?.notes?.map((note, index) => (
        <p key={index} className="text-sm font-medium before:content-['•'] before:mr-2 px-2">
          {note}
        </p>
      ))}
    </section>
  );
};

export default ImportantNotes;
